<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th scope="col" class="text-capitalize">
                {{ "common.date" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.transactionId" | translate }}
              </th>
              <th scope="col" class="text-capitalize"></th>
              <th scope="col" class="text-capitalize">
                {{ "common.type" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.status" | translate }}
              </th>
              <th scope="col" class="text-capitalize col-notif">
                {{ "common.notification" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.requestedValue" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.fees" | translate }}
              </th>
              <th scope="col" class="text-capitalize">{{ nameColumn }}</th>
              <th scope="col" class="text-capitalize">
                {{ "common.amountMoved" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.origin" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.description" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.externalId" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let transaction of transactions">
              <td>
                <span>{{
                  transaction.data | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                }}</span>
              </td>
              <td>
                <span>{{ transaction.codigo }}</span>
              </td>
              <td>
                <span
                  ><i
                    class="btn btn-sm fe fe-search"
                    (click)="openDetails(transaction)"
                  ></i
                ></span>
              </td>
              <td>
                <span class="text-{{ transaction.textColor }}">{{
                  transaction.tipo | label : "type"
                }}</span>
              </td>
              <td>
                <span>{{ transaction.status }}</span>
              </td>
              <td class="col-notif">
                <ng-container
                  *ngIf="
                    (transaction.aplicacao === 'API' ||
                      transaction.aplicacao === 'TEF') &&
                      (transaction.userNotificationWebHook === 'SUCESSO' ||
                        transaction.userNotificationWebHook === 'FALHA' ||
                        transaction.userNotificationWebHook === 'PENDENTE');
                    else minusNotif
                  "
                >
                  <span
                    class="notif-square"
                    [ngClass]="{
                      'bg-success-transparent text-success':
                        transaction.userNotificationWebHook === 'SUCESSO',
                      'bg-danger-transparent text-danger':
                        transaction.userNotificationWebHook === 'FALHA',
                      'bg-warning-transparent text-warning':
                        transaction.userNotificationWebHook === 'PENDENTE'
                    }"
                    [title]="
                      'Notificação Webhook: ' +
                      transaction.userNotificationWebHook
                    "
                  >
                    <i
                      class="fe"
                      [ngClass]="{
                        'fe-check':
                          transaction.userNotificationWebHook === 'SUCESSO',
                        'fe-x': transaction.userNotificationWebHook === 'FALHA',
                        'fe-clock':
                          transaction.userNotificationWebHook === 'PENDENTE'
                      }"
                    ></i>
                  </span>
                </ng-container>

                <ng-template #minusNotif>
                  <span
                    class="notif-square bg-light-gray"
                    title="Sem notificação"
                  >
                    <i class="fe fe-minus"></i>
                  </span>
                </ng-template>
              </td>
              <td>
                <span>{{ transaction.valorSolicitado | formatCurrency }}</span>
              </td>
              <td>
                <span>{{
                  (!transaction.splitTaxa && !transaction.splitTaxaAdm
                    ? transaction.taxaAdministrativa
                    : transaction.splitTaxaAdm
                  ) | formatCurrency
                }}</span>
              </td>
              <td>
                <span>{{ transaction.splitTaxa | formatCurrency }}</span>
              </td>
              <td>
                <span>{{ transaction.valorMovimentado | formatCurrency }}</span>
              </td>
              <td>
                <span>{{ transaction.origem }}</span>
              </td>
              <td>
                <span>{{ transaction.responsavel }}</span>
              </td>
              <td>
                <span>{{ transaction.idempotencyKey }}</span>
              </td>
            </tr>
            <tr *ngIf="transactions.length == 0">
              <td colspan="13">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>

<ng-template #transactionDetailsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "common.transactionDetails" | translate }} – #{{
        selectedTransaction?.id
      }}
    </h5>
    <button class="btn-close" (click)="modal.close()"></button>
  </div>

  <ng-container *ngIf="selectedTransaction; else loading">
    <div class="modal-body p-0">
      <div class="table-responsive">
        <table class="table table-sm mb-0">
          <tbody>
            <tr>
              <th>{{ "common.identifier" | translate }}</th>
              <td>{{ selectedTransaction.identifier }}</td>
            </tr>
            <tr>
              <th>{{ "common.bankId" | translate }}</th>
              <td>{{ selectedTransaction.endToEndId || "-" }}</td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>
            <tr>
              <th>{{ "common.dateIssue" | translate }}</th>
              <td>{{ fmtDate(selectedTransaction.dateIssue) }}</td>
            </tr>
            <tr>
              <th>{{ "common.confirmationDate" | translate }}</th>
              <td>{{ fmtDate(selectedTransaction.confirmationDate) }}</td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>
            <tr>
              <th>{{ "common.type" | translate }}</th>
              <td>{{ selectedTransaction.type }}</td>
            </tr>
            <tr>
              <th>{{ "common.status" | translate }}</th>
              <td>
                <span
                  *ngIf="selectedTransaction.status"
                  class="status-badge"
                  [ngClass]="formatStatusClass(selectedTransaction.status)"
                >
                  {{ selectedTransaction.status | label : "status" }}
                </span>
                <span *ngIf="!selectedTransaction.status">-</span>
              </td>
            </tr>
            <tr>
              <th>{{ "common.origin" | translate }}</th>
              <td>{{ selectedTransaction.origin }}</td>
            </tr>
            <tr>
              <th>{{ "common.application" | translate }}</th>
              <td>{{ selectedTransaction.application }}</td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>

            <!-- ====================== PERSON ====================== -->
            <ng-container *ngIf="selectedTransaction?.person as p">
              <ng-container *ngIf="originCurrency === 'BRL'; else intlPerson">
                <tr>
                  <th>{{ "common.document" | translate }}</th>
                  <td>{{ p.cpf || "-" }}</td>
                </tr>
                <tr>
                  <th>{{ "common.name" | translate }}</th>
                  <td>{{ p.name || "-" }}</td>
                </tr>
                <tr *ngIf="selectedTransaction?.type === 'SAQUE'">
                  <th>{{ "common.keyType" | translate }}</th>
                  <td>{{ p.pixKeyTypes || "-" }}</td>
                </tr>
                <tr *ngIf="selectedTransaction?.type === 'SAQUE'">
                  <th>{{ "common.pixKey" | translate }}</th>
                  <td  style="word-break: break-word;">{{ p.pixKey || "-" }}</td>
                </tr>
                <tr>
                  <th>{{ "common.bankName" | translate }}</th>
                  <td>{{ p.bankName || "-" }}</td>
                </tr>
                <tr *ngIf="selectedTransaction?.type === 'SAQUE'">
                  <th>Documento Recebedor</th>
                  <td>{{ p.cpfMask || "-" }}</td>
                </tr>
                <tr *ngIf="selectedTransaction?.type === 'DEPOSITO'">
                  <th>{{ "common.payerDocument" | translate }}</th>
                  <td>{{ p.cpfMask || "-" }}</td>
                </tr>
                <tr>
                  <td colspan="2" class="p-4"></td>
                </tr>
              </ng-container>

              <ng-template #intlPerson>
                <tr>
                  <th>{{ "common.name" | translate }}</th>
                  <td>{{ p.name || "-" }}</td>
                </tr>
                <tr>
                  <th>{{ "common.document" | translate }}</th>
                  <td>{{ p.documentName || "-" }}</td>
                </tr>
                <tr>
                  <th>{{ "common.phone" | translate }}</th>
                  <td>{{ p.phone || "-" }}</td>
                </tr>
                <tr>
                  <th>{{ "common.email" | translate }}</th>
                  <td>{{ p.email || "-" }}</td>
                </tr>
                <tr>
                  <td colspan="2" class="p-4"></td>
                </tr>
              </ng-template>
            </ng-container>

            <!-- ====================== METADADOS ====================== -->
            <tr>
              <th>{{ "common.callbackUrl" | translate }}</th>
              <td>{{ selectedTransaction.callbackUrl || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.externalId" | translate }}</th>
              <td>{{ selectedTransaction.idempotencyKey || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.ip" | translate }}</th>
              <td>{{ selectedTransaction.ip || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.accountUser" | translate }}</th>
              <td>{{ selectedTransaction.userApprove || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.cancelReason" | translate }}</th>
              <td>{{ selectedTransaction.mensageCancel || "-" }}</td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>
            <!-- ====================== VALORES ====================== -->
            <tr>
              <th>{{ "common.requestedValue" | translate }}</th>
              <td>{{ selectedTransaction.requestedValue | formatCurrency }}</td>
            </tr>
            <tr>
              <th>{{ "common.fee" | translate }}</th>
              <td>{{ selectedTransaction.splitTaxaAdm | formatCurrency }}</td>
            </tr>
            <tr>
              <th>{{ "common.split" | translate }}</th>
              <td>{{ selectedTransaction.splitTaxa | formatCurrency }}</td>
            </tr>
            <tr>
              <th>{{ "common.amountMoved" | translate }}</th>
              <td>{{ selectedTransaction.movedValue | formatCurrency }}</td>
            </tr>

            <!-- ====================== SPLIT NA TRANSAÇÃO ====================== -->
            <ng-container
              *ngIf="selectedTransaction?.splitConfiguration?.length"
            >
              <tr>
                <td colspan="2" class="p-4"></td>
              </tr>
              <tr class="heading">
                <th colspan="2">Split na Transação</th>
              </tr>

              <tr>
                <th>ID Conta</th>
                <td>
                  {{
                    selectedTransaction.splitConfiguration[0]?.accountId || "-"
                  }}
                </td>
              </tr>

              <tr>
                <th>Descrição</th>
                <td>
                  {{ selectedTransaction.splitAccountIdDescription || "-" }}
                </td>
              </tr>

              <tr>
                <th>Split</th>
                <td>
                  {{
                    selectedTransaction.splitConfiguration[0]?.taxPercent || 0
                      | number : "1.2-2"
                  }}% +
                  {{
                    selectedTransaction.splitConfiguration[0]?.taxValue || 0
                      | formatCurrency
                  }}
                </td>
              </tr>

              <tr>
                <th>Valor de Split</th>
                <td>
                  {{ selectedTransaction.splitAccountIdValue | formatCurrency }}
                </td>
              </tr>
            </ng-container>

            <!-- ====================== ORIGEM DA TRANSAÇÃO ====================== -->
            <ng-container
              *ngIf="
                (selectedTransaction?.origin === 'COMISSÃO' ||
                  selectedTransaction?.origin === 'TAXA BANCÁRIA' ||
                  selectedTransaction?.origin === 'TEF' ||
                  selectedTransaction?.origin === 'REEMBOLSO') &&
                selectedTransaction?.parentId
              "
            >
              <tr>
                <td colspan="2" class="p-4"></td>
              </tr>
              <tr class="heading">
                <th colspan="2">Origem da Transação</th>
              </tr>

              <tr>
                <th>ID Origem</th>
                <td>{{ selectedTransaction.parentTransactionId || "-" }}</td>
              </tr>

              <tr>
                <th>Tipo</th>
                <td>{{ selectedTransaction.parentId?.type || "-" }}</td>
              </tr>

              <tr>
                <th>Método</th>
                <td>
                  {{
                    selectedTransaction.parentId?.origin
                      ? selectedTransaction.parentId.origin +
                        (selectedTransaction.parentId.application
                          ? " (" +
                            selectedTransaction.parentId.application +
                            ")"
                          : "")
                      : "-"
                  }}
                </td>
              </tr>

              <tr>
                <th>Valor</th>
                <td>
                  {{
                    selectedTransaction.parentId?.requestedValue
                      | formatCurrency
                  }}
                </td>
              </tr>
            </ng-container>

            <!-- ====================== WEBHOOK HISTORY ====================== -->
            <ng-container
              *ngIf="
                (selectedTransaction?.application === 'API' ||
                  selectedTransaction?.application === 'TEF') &&
                selectedTransaction?.webHookHistory?.length
              "
            >
              <tr>
                <td colspan="2" class="p-4"></td>
              </tr>
              <tr class="heading">
                <th colspan="2">{{ "common.webhookHistory" | translate }}</th>
              </tr>

              <ng-container
                *ngFor="
                  let w of selectedTransaction.webHookHistory;
                  let i = index
                "
              >
                <tr>
                  <th>Status</th>
                  <td>{{ w?.payload?.status || "-" }}</td>
                </tr>
                <tr>
                  <th>Data de envio</th>
                  <td>{{ fmtDate(w?.sendDate) || "-" }}</td>
                </tr>
                <tr>
                  <th>{{ "common.dispatchConfirmation" | translate }}</th>
                  <td>
                    <span
                      class="status-badge"
                      [ngClass]="
                        w?.success ? 'status-realizado' : 'status-cancelado'
                      "
                    >
                      {{ w?.success ? "Sucesso" : "Falha" }}
                    </span>
                  </td>
                </tr>

                <tr *ngIf="i < selectedTransaction.webHookHistory.length - 1">
                  <td colspan="2" class="p-2"></td>
                </tr>
              </ng-container>
            </ng-container>

            <!-- ====================== CRYPTO (somente quando houver) ====================== -->
            <ng-container *ngIf="selectedTransaction?.cryptoTransaction">
              <tr>
                <td colspan="2" class="p-4"></td>
              </tr>

              <tr>
                <th>Moeda</th>
                <td>
                  {{
                    selectedTransaction.symbol?.name ||
                      selectedTransaction.cryptoTransaction?.symbol ||
                      "-"
                  }}
                </td>
              </tr>

              <tr>
                <th>Valor cripto</th>
                <td>
                  $
                  {{
                    selectedTransaction.cryptoTransaction?.cryptoValue != null
                      ? (selectedTransaction.cryptoTransaction.cryptoValue
                        | number : "1.0-4")
                      : "-"
                  }}
                </td>
              </tr>

              <tr>
                <th>Status cripto</th>
                <td>
                  <span
                    *ngIf="selectedTransaction.cryptoTransaction?.status"
                    class="status-badge"
                    [ngClass]="
                      formatStatusClass(
                        selectedTransaction.cryptoTransaction.status
                      )
                    "
                  >
                    {{
                      selectedTransaction.cryptoTransaction.status
                        | label : "status"
                    }}
                  </span>
                  <span *ngIf="!selectedTransaction.cryptoTransaction?.status"
                    >-</span
                  >
                </td>
              </tr>

              <tr>
                <th>Carteira</th>
                <td>
                  {{
                    selectedTransaction.wallet?.description ||
                      selectedTransaction.cryptoTransaction?.wallet ||
                      "-"
                  }}
                </td>
              </tr>

              <tr>
                <th>Hash carteira</th>
                <td>
                  {{ selectedTransaction.wallet?.hash || "-" }}
                </td>
              </tr>

              <tr>
                <th>Rede</th>
                <td>{{ selectedTransaction.wallet?.network || "-" }}</td>
              </tr>

              <tr>
                <th>TxId</th>
                <td>
                  {{ selectedTransaction.cryptoTransaction?.txId || "-" }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer justify-content-start">
      <button
        *ngIf="canDownloadReceipt"
        class="our-button btn btn-pill btn-primary me-2"
        (click)="downloadReceipt(tableRowForReceipt)"
      >
        <i class="fe fe-download me-2"></i>
        {{ "common.downloadReceipt" | translate }}
      </button>
      
      <button
        *ngIf="canResendRefund"
        class="our-button btn btn-pill btn-primary me-2"
        (click)="resendRefund()"
        [disabled]="isRefunding"
      >
        <i class="fe fe-refresh-cw me-2"></i>
        {{ "common.resendRefund" | translate }}
      </button>
      
      <button
        *ngIf="canResendWebhook"
        class="our-button btn btn-pill btn-primary me-2"
        (click)="resendWebhook(selectedTransaction)"
      >
        <i class="fe fe-refresh-cw me-2"></i>
        {{ "common.resendWebhook" | translate }}
      </button>
      <button
        class="our-button btn btn-pill btn-primary ms-auto"
        (click)="modal.close()"
      >
        {{ "common.close" | translate }}
      </button>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="d-flex justify-content-center p-5">
      <div class="spinner-border"></div>
    </div>
  </ng-template>
</ng-template>
